<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2 pb-4">
            <b-button block variant="primary" outline size="lg" @click="toggleAddDomainModal">
              <i class="fas fa-plus"></i>
              Add
            </b-button>
        </div>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="domains"
                :fields="fields"
                class="mb-0 table-borderless"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:cell(verified_at)="data">
                  {{ data.item.verified_at | formatDate | notAvailable }}
                </template>
                <template v-slot:cell(action)="data">
                  <b-button
                    @click="toUpdateItem = data.item.id"
                    variant="outline-warning mr-2"
                    size="sm"
                  >
                    <i class="ri-ball-pen-fill m-0"></i>
                  </b-button>
                  <b-button
                    @click="verifyDomain(data.item.id)"
                    variant="outline-success mr-2"
                    size="sm"
                  >
                    <i class="ri-check-line m-0"></i>
                  </b-button>
                 <b-button
                  @click="toDeleteItem = data.item.id"
                  variant="outline-danger"
                  size="sm"
                >
                  <i class="ri-delete-bin-line m-0"></i>
                </b-button>
                </template>
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
            <b-modal
                  title="Add new domain"
                  id="add-domain-modal"
                  hide-footer
                  cancel-title="Close"
                >
                  <FormulateForm
                    name="addDomain"
                    @submit="submitHandler"
                    v-model="formValues"
                    data-cy="add-domain-form"
                    #default="{ isValid }"
                  >
                    <b-row>
                      <b-col>
                        <b-alert
                          :show="true"
                          variant="primary"
                          class="bg-white"
                        >
                          <div class="iq-alert-text">
                            <p>
                              Set your domain and press
                              <strong>Submit domain</strong> button to activate
                              Omnicrane's consultative support available at
                              <strong>support@omnicrane.com</strong>.
                            </p>
                            <p>
                              Our consultant will generate all the necessary
                              parameters for modifying your DNS record and send
                              the data to the email
                              <strong>{{ profileEmail }}</strong
                              >.
                            </p>
                          </div>
                        </b-alert>
                      </b-col>
                    </b-row>
                    <b-row class="d-flex align-items-baseline">
                      <b-col>
                        <b-form-group>
                          <FormulateInput
                            id="domain"
                            name="domain"
                            type="text"
                            input-class="form-control"
                            data-cy="name-input"
                            
                            :validation="[['matches',/^([a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.)+[a-zA-Z]{2,}$/]]"
                            :validation-messages="{ matches: 'Must be valid domain.' }"
                            error-behavior="value"
                            :disabled="isUpdating"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col class="mb-2">
                        <b-button
                          block
                          type="submit"
                          variant="primary"
                          :disabled="!formValues.domain || isUpdating || !isValid"
                          data-cy="submit-button"
                          >{{
                            isUpdating
                              ? "Saving domain"
                              : "Save domain"
                          }}</b-button
                        >
                      </b-col>
                    </b-row>
                  </FormulateForm>
                </b-modal>
      <b-modal
        id="delete-domain-modal"
        :visible="!!toDeleteItem"
        title="Delete domain"
        @hidden="toDeleteItem = null"
      >
      <p>
        Domain
        <strong>{{ toDeleteDomain ? `${toDeleteDomain.name}` : null }}</strong>
        will be deleted.
      </p>
      <p>Are you sure?</p>
      <template #modal-footer="{}">
        <b-button size="sm" variant="outline-dark" @click="toDeleteItem = null"
          >Cancel</b-button
        >
        <b-button size="sm" variant="danger" @click="deleteItem(toDeleteItem)"
          >Delete</b-button
        >
      </template>
    </b-modal>
     <b-modal
      id="update-domain-modal"
      :visible="!!toUpdateItem"
      title="Update domain"
      hide-footer
      @hidden="toUpdateItem = null"
    >
      <FormulateForm
                    name="updateDomain"
                    @submit="submitUpdateHandler"
                    v-model="updateFormValues"
                    data-cy="update-domain-form"
                    #default="{ isValid }"
                  >
                    <b-row>
                      <b-col>
                        <b-alert
                          :show="true"
                          variant="primary"
                          class="bg-white"
                        >
                          <div class="iq-alert-text">
                            <p>
                              Change your domain and press
                              <strong>Change domain</strong> button to activate
                              Omnicrane's consultative support available at
                              <strong>support@omnicrane.com</strong>.
                            </p>
                            <p>
                              Our consultant will regenerate all the necessary
                              parameters for modifying your DNS record and send
                              the data to the email
                              <strong>{{ profileEmail }}</strong
                              >.
                            </p>
                          </div>
                        </b-alert>
                      </b-col>
                    </b-row>
                    <b-row class="d-flex align-items-baseline">
                      <b-col>
                        <b-form-group>
                          <FormulateInput
                            id="domain"
                            name="domain"
                            type="text"
                            input-class="form-control"
                            data-cy="name-input"
                            :validation="[['matches',/^([a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.)+[a-zA-Z]{2,}$/]]"
                            :validation-messages="{ matches: 'Must be valid domain.' }"
                            error-behavior="value"
                            :disabled="isUpdating"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-right">
                        <b-button size="sm" class="mr-2" variant="outline-dark" @click="toUpdateItem = null"
          >Cancel</b-button
        >
        <b-button size="sm" variant="primary"  :disabled="!isValid" @click="submitUpdateHandler()"
          >Update</b-button
        >
                      </b-col>
                    </b-row>
                  </FormulateForm>
        
    </b-modal>
    </div>
  </div>
</template>
<script>
import { core } from "../../config/pluginInit";
import { accessToken, parseJwt } from "../../Utils/auth";
import gql from "graphql-tag";
import { getAccountSync } from "../../Utils/account";
const LIST_DOMAINS = gql`
query listDomains {
  domains {
    id
    name
    verified_at
  }
}
`;
const PROFILE = gql`
  query profile($id: uuid!) {
    users_by_pk(id: $id) {
      id
      email
      first_name
      last_name
      role
      organization {
        id
        name
      }
    }
  }
`;
const GET_ORGANIZATION = gql`
  query myOrganization($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      organization {
        id
        organization_settings {
          id
        }
      }
    }
  }
`;
const ADD_DOMAIN_MUTATION = gql`
mutation addDomain($name: String!, $organizationSettingsId: uuid!) {
  insert_domains_one(
    object: {
      name: $name,
      organization_settings_id: $organizationSettingsId
    }
  ){
    id
    name
  }
}
`;
const UPDATE_DOMAIN_MUTATION = gql`
  mutation updateDomain($id: uuid!, $name: String!) {
    updateDomain(id: $id, name: $name) {
      id
      name
    }
  }
`;
const DELETE_DOMAIN_MUTATION = gql`
  mutation deleteDomain($id: uuid!) {
    delete_domains_by_pk(
      id: $id
    ){
      id
    }
  }
`;
const VERIFY_DOMAIN_MUTATION = gql`
  mutation verifyDomain($id: uuid!) {
    verifyDomain(id: $id) {
      domainVerifiedAt
    }
  }
`;
export default {
  name: "Domains",
  data() {
    return {
      isUpdating: false,
      showAddDomainModal: false,
      userId: getAccountSync()?.userId,
      fields: [
        { key: "name", title: "Name", sortable: true },
        { key: "verified_at", title: "Verified at", sortable: true },
        { key: "action", title: "Action", sortable: false }
      ],
      formValues: {
        domain: ""
      },
      updateFormValues: {
        domain: "",
      },
      toDeleteItem: null,
      toUpdateItem: null,
    };
  },
  apollo: {
    domains() {
      return {
        query: LIST_DOMAINS,
      };
    },
    organization() {
      return {
        query: GET_ORGANIZATION,
        variables: {
          userId: this.userId
        },
        update: data => {
          this.formValues.domain =
            data.users_by_pk?.organization?.organization_settings.domain || "";
          return data.users_by_pk?.organization;
        }
      };
    },
    profile: {
      query: PROFILE,
      variables() {
        const { sub } = parseJwt(accessToken());
        return {
          id: sub
        };
      },
      update: data => {
        return data.users_by_pk;
      }
    }
  },
  methods: {
    async submitHandler() {
      this.isUpdating = true;
      try {
        await this.$apollo.mutate({
          mutation: ADD_DOMAIN_MUTATION,
          variables: {
            organizationSettingsId: this.organization?.organization_settings?.id,
            name: this.formValues.domain
          }
        });
        this.$toast.success(`Domain added`);
        this.$bvModal.hide("add-domain-modal");
        this.$apollo.queries.domains.refetch();
      } catch (error) {
        console.log(error);
        this.$toast.error(`Failed to add domain: ${error.message}`);
      }
      this.isUpdating = false;
    },
    async submitUpdateHandler() {
      this.isUpdating = true;
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_DOMAIN_MUTATION,
          variables: {
            id: this?.toUpdateDomain.id,
            name: this.updateFormValues.domain
          }
        });
        this.$toast.success(`Domain updated`);
        this.$bvModal.hide("update-domain-modal");
        this.$apollo.queries.domains.refetch();
      } catch (error) {
        console.log(error);
        this.$toast.error(`Failed to update domain: ${error.message}`);
      }
      this.isUpdating = false;
    },
    async deleteItem(id){
      try {
        await this.$apollo.mutate({
          mutation: DELETE_DOMAIN_MUTATION,
          variables: {
            id
          }
        });
        this.$toast.success(`Domain deleted`);
        this.$bvModal.hide("delete-domain-modal");
        this.$apollo.queries.domains.refetch();
      } catch (error) {
        console.log(error);
        this.$toast.error(`Failed to delete domain: ${error.message}`);
      }
    },
    async verifyDomain(id) {
      this.isVerifying = true;
      try {
        await this.$apollo.mutate({
          mutation: VERIFY_DOMAIN_MUTATION,
          variables: {
            id
          }
        });
        this.$toast.success(`Domain verification processed`);
        this.$apollo.queries.domains.refetch();
      } catch (error) {
        this.$toast.error(`Domain not verified.`);
      }
      this.isVerifying = false;
    },
    toggleAddDomainModal() {
      this.$bvModal.show("add-domain-modal");
    }
  },
  computed: {
    profileEmail() {
      return this?.profile?.email;
    },
    toDeleteDomain() {
      if (!this.toDeleteItem) {
        return null;
      }
      const d = this.domains.find(d => d.id === this.toDeleteItem);
      if (!d) {
        return null;
      }
      return d;
    },
    toUpdateDomain() {
      if (!this.toUpdateItem) {
        return null;
      }
      const d = this.domains.find(d => d.id === this.toUpdateItem);
      if (!d) {
        return null;
      }
      return d;
    }

  },
  watch: {
    toUpdateItem: {
      handler(newData, oldData) {
        console.log('toUpdateItem:',newData);
        if (newData) {
          this.updateFormValues.domain = this.domains.filter(d => d.id === newData)?.[0].name;
        } else {
          this.updateFormValues.domain = "";
        }
      }
    }

  },
  mounted() {
    core.index();
  }
};
</script>
